import { groupArrayByKeys } from '@campus/utils';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LearnerProfileStrandInterface } from '../../+models/LearnerProfileStrand.interface';
import { NAME, selectAll, selectEntities, selectIds, selectTotal, State } from './learner-profile-strand.reducer';

export const selectLearnerProfileStrandState = createFeatureSelector<State>(NAME);

export const getError = createSelector(selectLearnerProfileStrandState, (state: State) => state.error);

export const getLoaded = createSelector(selectLearnerProfileStrandState, (state: State) => state.loaded);

export const getAll = createSelector(selectLearnerProfileStrandState, selectAll);

export const getCount = createSelector(selectLearnerProfileStrandState, selectTotal);

export const getIds = createSelector(selectLearnerProfileStrandState, selectIds);

export const getAllEntities = createSelector(selectLearnerProfileStrandState, selectEntities);

/**
 * returns array of objects in the order of the given ids
 * @example
 * learnerProfileStrand$: LearnerProfileStrandInterface[] = this.store.pipe(
    select(LearnerProfileStrandQueries.getByIds, { ids: [2, 1, 3] })
  );
 */
export const getByIds = createSelector(selectLearnerProfileStrandState, (state: State, props: { ids: number[] }) => {
  return props.ids.map((id) => state.entities[id]);
});

/**
 * returns array of objects in the order of the given ids
 * @example
 * learnerProfileStrand$: LearnerProfileStrandInterface = this.store.pipe(
    select(LearnerProfileStrandQueries.getById, { id: 3 })
  );
 */
export const getById = createSelector(
  selectLearnerProfileStrandState,
  (state: State, props: { id: number }) => state.entities[props.id]
);

export const getByPersonIdByStrandId = createSelector(getAll, (learnerProfiles: LearnerProfileStrandInterface[]) =>
  groupArrayByKeys(learnerProfiles, ['personId', 'strandGuid'], null, true)
);
